import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";

const CategoryContainer = styled.div`
    padding: 1em;
    flex: 1;
    
    @media (max-width:992px){
        flex: 0 0 50%;
        margin-bottom: 2em;
    }
    
    @media (max-width:767px){
        padding: 0;
    }
`;

const CategoryImage = styled.img`
    max-width: 100%;
    height:auto;
    margin-bottom:.8em;
`;

class CategoryHolderComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        const { title, image, summary, link , t} = this.props;
      
        return (
            <CategoryContainer>
                <a href={link}><CategoryImage src={image} alt={title} className="border-radius-default"/></a>
                <a href={link} className="blue1 text-center"><div className="mb-0 h4">{title}</div></a>
                {summary && (<p className="text-justify">{summary}</p>)}
                <div className="mx-3 mx-sm-0">
                    <a href={link} className="btn btn-block btn-secondary mt-3">{t('showvillas')}</a>
                </div>                
            </CategoryContainer>
        );
    }
}

export const CategoryHolder = withTranslator(CategoryHolderComponent);